module.exports = __webpack_public_path__ + "pc/img/main-work-img-02.e2e3e470.png";